import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class NoAuthGuard implements CanActivate {
    constructor(private authService: AuthService) {}
    canActivate(): Observable<boolean> {
        return this.authService.user.pipe(
            map(auth => {
                return !auth;
            })
        );
    }
}



// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/services/no-auth.guard.ts